
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const internationalizeList = (ids, tagName, attributes) => {

    return ids.map((id, idx) => {

        const checkIfBooleanOrNull = value => {
            return value === null || typeof value === 'boolean';
        };

        const resolvedId = checkIfBooleanOrNull(id) ?
            (id ? 'common.yes' : 'common.no') :
            typeof id === 'object' ? id.id : id;

        const resolvedReplacements = typeof id === 'object' ?
            Object
                .entries(id.replacements)
                .reduce((rr, [ k, v ]) => {
                    return {
                        ...rr,
                        [k]: (v === '' || v === null) ? ' ' : v
                    };
                }, {}) :
            {};
        
        return React.createElement(
            tagName,
            attributes ?
                {
                    ...attributes,
                    ...(id.customClassName ? { className: id.customClassName } : {}),
                    key: `${resolvedId}_${idx}`
                } :
                {
                    key: `${resolvedId}_${idx}`,
                    ...(id.customClassName ? { className: id.customClassName } : {})
                },
            <FormattedMessage
                key={`${resolvedId}_${idx}`}
                id={resolvedId}
                values={resolvedReplacements}
            />
        );
    });
};